import React, { useState } from 'react';
import {
  makeStyles, Table, TableBody, TableRow, TableCell, Typography, Box, Button,
} from '@material-ui/core';
import { withTranslation } from 'config/i18n';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useStyles = makeStyles((theme) => ({
  table: {
    '& [class*="MuiTableCell-root"]': {
      padding: `${theme.spacing(1, 0)} !important`,
    },
  },
  tRow: {
    backgroundColor: 'transparent !important',

    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.grey['50']}`,
    },
  },
  tCell: {
    borderBottom: 'none',
  },
  title: {
    fontWeight: '500',
    color: theme.palette.grey['800'],
  },
  desc: {
    color: theme.palette.secondary.dark,
  },
  btn: {
    display: 'block',
    margin: theme.spacing(2, 'auto', 0),
  },
  btnArrow: {
    display: 'block',
    margin: '0',
  },
}));

const TechnicalDetails = (props) => {
  const classes = useStyles();
  const { t, data } = props;
  const dataLength = data.length;
  const viewedItems = 9;
  const [itemsCount, setRowCount] = useState(viewedItems);

  const showMoreToggle = () => {
    setRowCount(itemsCount == dataLength ? viewedItems : dataLength);
  };

  return (
    <>
      <Box>
        <Table className={classes.table}>
          <TableBody>
            {data.slice(0, itemsCount).map((detail) => (
              <TableRow key={detail.name + detail.value} classes={{ root: classes.tRow }}>
                <TableCell classes={{ root: classes.tCell }}>
                  <Typography variant="body2" component="span" className={classes.title}>
                    {detail.name}
                  </Typography>
                </TableCell>

                <TableCell classes={{ root: classes.tCell }}>
                  <Typography variant="body2" component="span" className={classes.desc}>
                    {detail.value}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {dataLength > viewedItems && (
        <Button
          color="secondary"
          endIcon={itemsCount == dataLength ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          onClick={showMoreToggle}
          classes={{ root: classes.btn, endIcon: classes.btnArrow }}
        >
            {itemsCount == dataLength ? t('fe_es_technical_details_component:hide') : t('fe_es_technical_details_component:show_all')}
        </Button>
        )}
      </Box>
    </>
  );
};

export default withTranslation('fe_es_technical_details_component')(TechnicalDetails);
